import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Button } from "@inmagik/magik-ui"
import { useMemo } from "react"
import MediaForm from "./MediaForm"
import type { Media } from "../../types"
import { initialValuesMedia, validationSchemaMedia } from "./MediaCommon"

export default function MediaModal({
  title,
  media,
  save,
  show,
  onClose,
}: {
  title: string
  media?: Media
  save: (values: Media, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
}) {
  const initialValues = useMemo(() => initialValuesMedia(media) as Media, [media])
  const validationSchema = useMemo(() => validationSchemaMedia(), [])

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <MediaForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
